import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";
import { AUTH0_NAMESPACE } from "./tenantContext";

export interface UserRoles {
  roles: string[];
  hasRole: (role: string) => boolean;
  isSales: boolean;
  isTeam: boolean;
  isAdmin: boolean;
}

export const useUserRoles = (): UserRoles => {
  const { user, isAuthenticated } = useAuth0();

  const userRoles = useMemo(() => {
    if (!isAuthenticated || !user) {
      return {
        roles: [],
        hasRole: () => false,
        isSales: false,
        isTeam: false,
        isAdmin: false,
      };
    }

    const rawRoles = user[`${AUTH0_NAMESPACE}/roles`];
    const roles: string[] = Array.isArray(rawRoles)
      ? rawRoles.filter((role): role is string => typeof role === "string")
      : [];

    const hasRole = (role: string): boolean => {
      return roles.includes(role);
    };

    return {
      roles,
      hasRole,
      isSales: hasRole("sales") || hasRole("Sales"),
      isTeam: hasRole("team") || hasRole("Team"),
      isAdmin: hasRole("admin") || hasRole("Admin") || hasRole("platform_admin"),
    };
  }, [user, isAuthenticated]);

  return userRoles;
};
